import styles from "./Flex.module.scss";
import classNames from "classnames";
import { FlexTypes } from "./Flex.types";

const Flex = ({
  children,
  direction = "row",
  align = "start",
  justify = "start",
  gap = 0,
  className = "",
  style,
  ariaLabel,
  tag = "div",
  role,
  onClick,
}: FlexTypes) => {
  const HtmlTag: any = tag;

  return (
    <HtmlTag
      role={role}
      aria-label={ariaLabel}
      style={{ gap: gap, ...style }}
      className={classNames(
        className,
        styles["flex"],
        styles[`flex--direction-${direction}`],
        styles[`flex--align-${align}`],
        styles[`flex--justify-${justify}`]
      )}
      onClick={onClick}
    >
      {children}
    </HtmlTag>
  );
};

export { Flex };
